import React from 'react';
import { Container, Grid, Typography, Card, CardContent, CardMedia, Button } from '@mui/material';
import HomeSlider from '../components/Homepage/sliders/slider';
import Latest from '../components/Homepage/Latest';
import FeaturedList from '../components/Homepage/Features';
import AreaList from '../components/Homepage/AreaListing';
import Testimonials from '../components/Homepage/Testimonials';
import Blogs from '../components/Homepage/Blogs';

const Home = () => {



  return (
    <Grid sx={{marginTop: { xs: '58px', sm: '58px', md: '100px' }}}>
      <Grid>
        <HomeSlider />
      </Grid>
      <Grid sx={{width:'90%' , margin:'30px auto'}}>
        <Latest/>
      </Grid>
      <Grid sx={{width:'90%' , margin:'30px auto'}}>
        <FeaturedList />
      </Grid>
      <Grid sx={{width:'90%' , margin:'30px auto'}}>
        <AreaList />
      </Grid>
      <Grid sx={{width:'90%' , margin:'30px auto'}}>
        <Testimonials />
      </Grid>
      <Grid sx={{width:'90%' , margin:'30px auto'}}>
        <Blogs />
      </Grid>
    </Grid>

  );
};

export default Home;
